export default __webpack_public_path__ + "33a20bfad2a67be9c2072bd672a2567e.png";